import { Task } from "@/bryntum-lib/models/Task";
import { SWIVU_TASK_DEFAULT_COLOR } from "@/other/configs/globalConfig";
import { MIXED_TASK_COLOR, MIXED_TASK_STYLE, STRIPED_TASK_STYLE } from "@/other/constants/TaskTypes";
import bgContrastHelper from "@/other/utils/bgUtils";
import { applyStripedBackground } from "@/other/utils/utils";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";

interface EntityTaskRendererProps {
  record: Task;
  onClick?: (task: Task) => void;
}

export const TaskRenderer = ({ record, onClick }: EntityTaskRendererProps) => {
  const { userPreferences } = useSwivuBryntumContext();
  const backgroundColor = record.color ? record.color : SWIVU_TASK_DEFAULT_COLOR;
  let globalColor = userPreferences?.getSetting("taskColor", "", true);
  let globalStyle = userPreferences?.getSetting("taskStyle", "", true);

  if (globalStyle === MIXED_TASK_STYLE) globalStyle = "";
  if (globalColor === MIXED_TASK_COLOR) globalColor = "";

  const isStripStyle = record?.taskStyle ? record.taskStyle === STRIPED_TASK_STYLE : globalStyle === STRIPED_TASK_STYLE;
  const contrastColor = bgContrastHelper(globalColor || backgroundColor, "#fff", "#000");

  const lineStylePermitsContrast = (lineStyle: string) => !["line", "dashed", "minimal", "hollow"].includes(lineStyle);
  const taskStyle = record.taskStyle || globalStyle || "plain";
  const canApplyBgContrast = isStripStyle || lineStylePermitsContrast(taskStyle);
  const color = canApplyBgContrast ? contrastColor || "#000" : "";

  const primaryColor = globalColor || backgroundColor;

  const stripedStyle = isStripStyle ? { background: applyStripedBackground(primaryColor) } : {};
  const colorStyle = !isStripStyle ? { color: primaryColor } : {};

  return (
    <div onClick={() => onClick?.(record)}>
      <div
        className={`b-sch-event-wrap b-sch-swivu-task-style b-style-${taskStyle} ${!isStripStyle ? "b-sch-custom-color" : "swivu-time-event"} swivu-unplanned-task w-full relative`}
        style={{
          pointerEvents: "auto",
          // @ts-expect-error --b-primary is not in the type definition
          "--b-primary": primaryColor
        }}
      >
        <div
          className="b-sch-event b-has-content"
          style={{
            flexDirection: "column",
            alignItems: "flex-start",
            whiteSpace: "inherit",
            ...stripedStyle,
            ...colorStyle
          }}
        >
          <div
            className={`b-sch-event-content ${!canApplyBgContrast ? "theme-text-color" : ""}`}
            style={{
              color,
              fontSize: "1em",
              alignItems: "center",
              padding: "0.5rem 0.75rem",
              width: "100%",
              ...(record.archived && { textDecoration: "line-through" })
            }}
          >
            {record.name || "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
};
